import ButtonBase from '@mui/material/ButtonBase';
import { JE_TABLE_CLASSES } from 'components/Tables/grid/StyledComponents';

import { styled, alpha } from '@mui/material/styles';
import { amber, indigo } from '@mui/material/colors';

export const JELinesTableWrapper = styled('div', { label: 'JELinesTableWrapper' })(() => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  marginBottom: 30,
  marginTop: 5,
}));

export const JELinesTableOverride = styled('div', { label: 'JELinesTableOverride' })(({ theme }) => ({
  width: '100%',
  display: 'flex',

  [`& .${JE_TABLE_CLASSES.COLGROUP_COL}`]: {
    width: 170,
  },

  [`& .${JE_TABLE_CLASSES.COLGROUP_COL_REMOVE}`]: {
    width: 30,
  },

  [`& .${JE_TABLE_CLASSES.ROW}`]: {
    '&:first-child': {
      [`& .${JE_TABLE_CLASSES.CELL}`]: {
        backgroundColor: theme.palette.grey[200],
      },
    },
    [`&:not(:first-child) .${JE_TABLE_CLASSES.CELL}`]: {
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
    },
  },

  [`& .${JE_TABLE_CLASSES.ROW_LINE}`]: {
    [`&.${JE_TABLE_CLASSES.ROW_ACTIVE}`]: {
      backgroundColor: indigo[50],

      [`& .${JE_TABLE_CLASSES.CELL_REMOVE}`]: {
        opacity: 1,
      },
    },

    [`&.${JE_TABLE_CLASSES.ROW_HOVERED}`]: {
      backgroundColor: amber[50],

      [`& .${JE_TABLE_CLASSES.CELL_REMOVE}`]: {
        opacity: 1,
      },
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL}`]: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    minWidth: 170,
    width: '50%',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: -1,
      left: -1,
      bottom: 2,
      borderRight: `1px solid ${theme.palette.grey[200]}`,
      zIndex: 0,
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL_REMOVE}`]: {
    padding: 4,
    opacity: 0,
    transition: 'opacity 0.3s',
  },

  [`& .${JE_TABLE_CLASSES.CELL_MANDATORY}`]: {
    border: `1px solid ${theme.palette.error.main}`,
    '&:before': {
      display: 'none',
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL_ACTIVE}`]: {
    border: `1px solid ${theme.palette.primary.light}`,

    [`&:before, & + .${JE_TABLE_CLASSES.CELL}:before`]: {
      display: 'none',
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL_PINNED}:nth-child(2):before`]: {
    display: 'none',
  },
}));

export const PinnedContainer = styled('div', { label: 'PinnedContainer' })(({ theme }) => ({
  flex: '1 1',
  position: 'relative',
  maxWidth: '70%',

  '&:after': {
    zIndex: 8,
    content: '""',
    position: 'absolute',
    display: 'block',

    right: 0,
    top: 0,
    bottom: 9,
    width: 3,
    backgroundColor: theme.palette.grey[200],
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
  },

  [`& .${JE_TABLE_CLASSES.TABLE}`]: {
    position: 'relative',
    zIndex: 10, // higher than dropdown toggle
  },
}));

export const PinnedScrolledContainer = styled('div', { label: 'PinnedScrolledContainer' })(({ theme }) => ({
  width: 'auto',
  overflow: 'hidden',
  overflowX: 'auto',
  paddingTop: 0,
  paddingBottom: 2,
  paddingLeft: 3,
  paddingRight: 3,

  '&::-webkit-scrollbar': {
    appearance: 'none',
    height: 7,
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: alpha(theme.palette.common.black, 0.5),
    boxShadow: `0 0 1px ${alpha(theme.palette.common.white, 0.5)}`,
  },
}));

export const FloatContainer = styled('div', { label: 'FloatContainer' })(() => ({
  position: 'relative',
  maxWidth: '100%',
  minWidth: 0,

  '&:hover > .MuiButtonBase-root': {
    opacity: 1,
  },
}));

export const FloatContent = styled('div', { label: 'FloatContent' })(({ theme }) => ({
  overflowX: 'auto',
  overflowY: 'hidden',
  position: 'relative',
  paddingBottom: 2,

  '&::-webkit-scrollbar': {
    appearance: 'none',
    height: 7,
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: alpha(theme.palette.common.black, 0.5),
    boxShadow: `0 0 1px ${alpha(theme.palette.common.white, 0.5)}`,
  },
}));

export const FloatContainerAction = styled(ButtonBase, {
  label: 'FloatContainerAction',
  shouldForwardProp: (propName) => propName !== 'type',
})(({ theme, type }) => ({
  position: 'absolute',
  width: 16,
  top: 0,
  bottom: 9,
  zIndex: 8,
  outline: '0 none',
  cursor: 'pointer',
  opacity: 0,
  transition: '0.3s opacity',
  color: theme.palette.common.white,
  background: alpha(theme.palette.common.black, 0.25),

  ...(type === 'prev' && { left: 0 }),
  ...(type === 'next' && { right: 0 }),

  '&:hover': {
    zIndex: 10,
    background: alpha(theme.palette.common.black, 0.45),
  },
  '&[disabled]': {
    display: 'none',
  },
}));
